import { useEffect, useState } from "react";
import {
  get_brand_name,
  get_types,
  update_brand_name,
} from "../../../reduxData/user/userAction";
import { useSelector } from "react-redux";

const useAttributes = () => {
  const [brands, setBrands] = useState([]);
  const [category, setCategory] = useState([]);
  const token = useSelector((state) => state.auth.accessToken);

  const handleGetBrands = async () => {
    const res = await get_brand_name();
    // const filterBrands = res?.data?.filter(i=>i?.is_community_brand);
    setBrands(res?.data || []);
  };

  const handleGetCategory = async () => {
    const res = await get_types();
    setCategory(res?.data || []);
  };

  const editBrand = async (data, id) => {
    if (!id) return null;
    try {
      const res = await update_brand_name(token, id, data);
      if (res) {
        handleGetBrands();
      }
      return res;
    } catch (error) {
      console.error("editBrand failed:", error);
      return null;
    }
  };

  useEffect(() => {
    handleGetBrands();
    handleGetCategory();
  }, []);

  return { brands, category, editBrand };
};

export default useAttributes;
